import { atom } from 'jotai';

export const showContactSellerModalAtom = atom(false);
